import { render, staticRenderFns } from "./MiscellaneousItemTiersForm.vue?vue&type=template&id=437946cc&scoped=true"
import script from "./MiscellaneousItemTiersForm.vue?vue&type=script&lang=js"
export * from "./MiscellaneousItemTiersForm.vue?vue&type=script&lang=js"
import style0 from "./MiscellaneousItemTiersForm.vue?vue&type=style&index=0&id=437946cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437946cc",
  null
  
)

export default component.exports